///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.grx_src_manager = abcsetup.dashboard.grx_src_manager || {};
abcsetup.dashboard.grx_src_manager.rfq = abcsetup.dashboard.grx_src_manager.rfq || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.grx_src_manager = {
    init: function () {
        // RFQ Event delete button clicked
        $(document).on('click', '.btn-pause', function () {
            var btn = $(this);
            $('.tooltips, .btn[title]').tooltip('hide');

            // The current event is already paused
            if ($(this).html().indexOf('play') > -1) {
                abcsetup.dashboard.grx_src_manager.rfq.pauseEvent(btn.data('id'));

                // Confirm and get reason to pause the event
            } else {
                abcsetup.alerts.prompt('Pause RFQ Bid Event', 'Please specify a reason to pause this event:', function (resp) {
                    if (resp[0] == true) {
                        abcsetup.dashboard.grx_src_manager.rfq.pauseEvent(btn.data('id'), resp[1]);
                    }
                }, true);
            }

            return false;
        });

        // RFQ Event delete button clicked
        $(document).on('click', '#rfq_events .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.prompt('Delete RFQ Bid Event', 'Please specify a reason to delete this event:', function (resp) {
                if (resp[0] == true) {
                    abcsetup.dashboard.grx_src_manager.rfq.deleteEvent(_this.data('id'), resp[1]);
                }
            }, true);

            return false;
        });

        // RFQ Event delete button clicked
        $(document).on('click', '#rfq_events .btn-restore', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete RFQ Event', 'Are you sure you want to restore this event?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.grx_src_manager.rfq.deleteEvent(_this.data('id'));
                }
            });

            return false;
        });

        // Init the RFQ comments lib
        abcsetup.rfq.comments.init();
        abcsetup.rfq.supply_issues.comments.init();
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  RFQ Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rfq: {
        /**
         *
         */
        pauseEvent: function (id, message = null) {
            abcsetup.dashboard.showLoading($('#rfq_panel'));
            $('#rfq_panel').find('.dataTables_wrapper').hide();

            axios.post('/api/rfq/bid_requests/' + id + '/pause', {message: message}).then(response => {
                window.location.reload();
            });
        },

        /**
         *
         */
        deleteEvent: function (id, message = null) {
            abcsetup.dashboard.showLoading($('#rfq_panel'));
            $('#rfq_panel').find('.dataTables_wrapper').hide();

            axios.delete('/rfq/bid_requests/' + id, {data: {message: message}}).then(response => {
                window.location.reload();
            });
        },
    },
}
